export class ScpTextAudiEntity{
    
    id:number;
    name:string;
    description:string;
    creationDate:string;
    userIdCreation:number;
    updateDate:string;
    userIdUpdate:number;
    active:boolean;

    constructor (){}
}